// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1_qhM","cls2":"RecommendedPodcastBadge-cls2_Tz_ RecommendedPodcastBadge-cls1_qhM"};